import React from "react";
import { useNavigate } from "react-router-dom";
import { EmptyList, Loading } from "../../../components";
import { Header } from "../../../components/header";
import { useCategories } from "../hooks";

export const Categories: React.FC = () => {
  const navigate = useNavigate();

  const { data, loading, error, refetch } = useCategories();

  const renderList = () => {
    if (loading) return <Loading />;
    if (data?.categories?.results?.length === 0) {
      return <EmptyList text="Aucune Category n'est enregistré" />;
    }

    return (
      <table className="table-auto w-full">
        <thead>
          <tr className="text-xs text-gray-500 text-left">
            <th className=" font-medium padding-table text-center">Nom</th>
            <th className=" font-medium padding-table text-center">Nb Site</th>
          </tr>
        </thead>
        <tbody>
          {data?.categories?.results?.map((category, index) => (
            <tr key={`category-${category.id}`} className={`text-xs`}>
              <td className="padding-table text-center py-3">
                <p
                  className="text-small cursor-pointer"
                  onClick={() => navigate(`/category/${category?.id}`)}
                >
                  {category?.name}
                </p>
              </td>

              <td className="padding-table text-center py-3">
                <p className="font-medium cursor-pointer">{category?.name}</p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <>
      <Header title="Categories" subtitle="Liste des categories" />

      <div className="main-container">
        <div className="flex flex-wrap -mx-4 items-center justify-between mb-2">
          <div className="w-full lg:w-1/3 px-4 flex items-center mb-4 lg:mb-0"></div>
          <div className="w-full lg:w-auto px-4 flex items-center justify-end">
            <button className="btn" onClick={() => refetch()}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="white"
              >
                <path d="M13.5 2c-5.621 0-10.211 4.443-10.475 10h-3.025l5 6.625 5-6.625h-2.975c.257-3.351 3.06-6 6.475-6 3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5c-1.863 0-3.542-.793-4.728-2.053l-2.427 3.216c1.877 1.754 4.389 2.837 7.155 2.837 5.79 0 10.5-4.71 10.5-10.5s-4.71-10.5-10.5-10.5z" />
              </svg>
            </button>
          </div>
        </div>

        <div className="p-4 mb-6 bg-white shadow rounded overflow-x-auto">
          {renderList()}
        </div>
      </div>
    </>
  );
};
